<template>
  <path
    id="ic_dashboard_24px"
    d="M3,14.111h8.889V3H3ZM3,23h8.889V16.333H3Zm11.111,0H23V11.889H14.111Zm0-20V9.667H23V3Z"
    transform="translate(-3 -3)" />
</template>
